import React, { ReactElement } from 'react';

import { Inject } from '@odinjs/odin';

import { FOUNDATION_ROUTES, StipulatorConfigurationService } from '@philips-emr/hpms-stipulator-commons';
import { Link, PanelAPI, SocialNetworksAPI, TextAPI } from '@philips-emr/tws-components';
import { DismissStyle, ThemeTonalRange, ToastLevel } from '@philips-emr/tws-constants';
import Controller, { OnCatch, OnClose, OnMount, OnSuccess } from '@philips-emr/tws-core/lib/client';
import { PromiseEvent } from '@philips-emr/tws-core/lib/component/types';
import { MessageService, ModalService, ThemeService, ToastService } from '@philips-emr/tws-core/lib/services';
import { ModalProps } from '@philips-emr/tws-core/lib/services/modal-service';
import { applicationModuleRegistry, LoginAPI } from '@philips-emr/tws-foundation';
import { getBreakpoint } from '@philips-emr/tws-utils';

import registerDinamico from '../app/registries/dinamico-register';
import { FragmentNames } from '../codegen';
import { LoginAliases } from '../codegen/constants/aliases';

import BaseController from './BaseController';
import './login.scss';

@Controller({ fragment: FragmentNames.LOGIN })
export default class LoginControler extends BaseController {

  @Inject(LoginAliases.LOGIN_COMPONENT)
  private loginAPI: LoginAPI;

  @Inject(LoginAliases.TEXT_INFO)
  private textInfoAPI: TextAPI;

  @Inject(LoginAliases.SOCIAL_NETWORKS)
  private socialNetworksAPI: SocialNetworksAPI;

  @Inject('panel-modal-politica-cookies')
  private panelCokies: PanelAPI;

  @OnMount(LoginAliases.LOGIN_COMPONENT)
  onLoginMount(): void {
    ThemeService.setContentTonalRange(StipulatorConfigurationService.getTonalidadeLogin());

    void StipulatorConfigurationService.getConfigurationData().then(data => {
      this.loginAPI.setLogo(data.dsUrlLogoHeaderLogin as string);

      const info = `${data.dsEndereco || ''}
      ${MessageService.translate('$expression.$299149')}: ${data.nrFoneContato || ''}
      ${MessageService.translate('stipulator.email')}: ${data.dsEmailRodape || ''}`;
      this.textInfoAPI.setValue(info);

      data.dsLinkFacebook && this.socialNetworksAPI.setFacebook(data.dsLinkFacebook as string);
      data.dsLinkLinkedin && this.socialNetworksAPI.setLinkedin(data.dsLinkLinkedin as string);
      data.dsLinkYoutube && this.socialNetworksAPI.setYoutube(data.dsLinkYoutube as string);
      data.dsLinkInstagram && this.socialNetworksAPI.setInstagram(data.dsLinkInstagram as string);
      data.dsLinkTwitter && this.socialNetworksAPI.setTwitter(data.dsLinkTwitter as string);
    });

    setTimeout(() => this.cookiesToast(), 1000);
  }

  private cookiesToast(): void {

    ToastService.open({
      id: 'c-toast-notification__message--cookies',
      title: MessageService.translate('$expression.$1034041'),
      message: MessageService.translate('stipulator.politica-cookies'),
      dismissible: true,
      dismissStyle: DismissStyle.BUTTON,
      showIcon: true,
      dismissExpression: 'Ok',
      action: this.getFilho(),
      level: ToastLevel.WARNING,
      highlight: true,
    });

  }

  private getFilho(): ReactElement {
    return (
      <Link onClick={() => this.showCookiesModal()} value={MessageService.translate('$expression.$1034041')} />
    );
  }

  private controleModalPoliticaCookie(controle: boolean): void {
    this.panelCokies.setVisible(controle);
  }

  @OnClose({ target: 'modal-politica-cookies' })
  onCloseModal(): void {
    this.controleModalPoliticaCookie(false);
  }

  @OnCatch(LoginAliases.LOGIN_COMPONENT)
  onCatch(event: PromiseEvent<Record<string, unknown>>): void {
    const response = event.response.response as Response;
    void response.json().then((content) => {
      this.showNotification(content);
      this.passwordExpired(content);
    }
    );
  }

  @OnSuccess(LoginAliases.LOGIN_COMPONENT)
  onSuccess (): void {
    if (!applicationModuleRegistry.get('dinamico')) {
      registerDinamico();
    }
  }

  showNotification(content: any): void {
    this.loginAPI.setNotification({
      message: content.message,
      level: ToastLevel.WARNING,
      highlight: true,
    });
  }

  passwordExpired(error: any): void {
    if (error.code) {
      const codigoErro = error.code[Object.keys(error.code)[0]];
      if (codigoErro == '870103') {
        const { username } = this.loginAPI.state;
        this.historyService.push(FOUNDATION_ROUTES.RENOVAR_SENHA_BY_USERNAME, { username });
      }
    }
  }

  showCookiesModal(): void {

    const modalWithFragment: ModalProps = {
      closeable: true,
      fragment: 'cookies',
      title: '$expression.$1034041',
      theme: ThemeTonalRange.ULTRA_LIGHT,
    };

    const breakpoints = getBreakpoint() as string;

    if (breakpoints == 'sm' || breakpoints == 'xsm') {
      ModalService.openFullscreen(modalWithFragment);
    } else {
      ModalService.openDialog(modalWithFragment);
    }

  }

}
